export default "https://cdn-static.gokick.com/assets/ac547ee441cd23ce845c1e2810a666ddd08d044b/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";